<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle" id="ch00_fm07_half1"><a id="page_xv"></a>Anna Seward and the End<br/>of the Eighteenth Century<a id="page_xvi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm07_half1.vue?25544d06